<svelte:head>

    <link rel='stylesheet' href='/global.css' />

</svelte:head>

<script>

    import {
        getPayoutsCount,
        getDashboard,
        downloadMemberCSV,
        getDashboardv2,
        downloadTurnoverCSV,
        downloadRedeemCSV
    } from "../api.svelte";
    import Header from "../utils/header.svelte"

    import { getContext, onMount } from "svelte";
    import {checkUnauthorized} from "../../utils/session";
    import dayjs from "dayjs";


    // vars
    const router = getContext('router');

    let data;
    let otherData;

    let selectedDate = 'all';

    let options = {
        'selected': selectedDate,
        'year': "",
        'start': "",
        'end': ""
    }

    const TRANSLATIONS = {
        "January": "Januar",
        "February": "Februar",
        "March": "März",
        "April": "April",
        "May": "Mai",
        "June": "Juni",
        "July": "Juli",
        "August": "August",
        "September": "September",
        "October": "Oktober",
        "November": "November",
        "December": "Dezember"
    }


    onMount(() => {

        // handleGetDashboardData().then((res) => {
        //
        //     console.log(res);
        // })

        handleGetDashboardDatav2().then((res) => {

            handleGetDashboardData().then((whatever) => {

            })

            console.log(res);
        })

    });

    let handleGetDashboardData = async () => {

        let now = dayjs();

        let currentDate = now.subtract(1, 'day').hour(0).minute(0).second(0).unix();
        let pastDate = now.subtract(1, 'day').hour(23).minute(59).second(59).unix();
        let firstDayMonth = now.month(now.month() - 1).date(1).hour(0).minute(0).second(0).unix();
        let lastDayMonth = now.month(now.month() - 1).date(31).hour(23).minute(59).second(59).unix();

        console.log(currentDate);
        console.log(pastDate);
        console.log(firstDayMonth);
        console.log(lastDayMonth);

        let result = await getDashboard(currentDate, pastDate, firstDayMonth, lastDayMonth);

        if (result['status'] !== 'success') {

            checkUnauthorized(router, result);
            console.log(result);

            return false;
        }

        otherData = result['data']

        return result;
    }

    let handleGetDashboardDatav2 = async () => {

        let result = await getDashboardv2(options);

        if (result['status'] !== 'success') {

            checkUnauthorized(router, result);
            console.log(result);

            return false;
        }

        data = result['data']

        console.log(data)

        return result;
    }

    let handleCsvDownload = async (typ) => {

        console.log(typ)
        console.log("whatever")

        if (typ === 'member') {
            downloadMemberCSV().then((res) => {});
        } else if(typ === 'turnover') {
            downloadTurnoverCSV().then((res) => {});
        } else {
            downloadRedeemCSV().then((res) => {});
        }

    };

    let handleDates = async (data) => {

        selectedDate = data.detail['selected']

        options = data.detail;

        await handleGetDashboardDatav2()

    }

</script>


<div id="overview-container">

    <div>
        <h1>Übersicht</h1>

        <div>
            <Header
            on:dates={handleDates}
            selected={selectedDate}
            />
        </div>
    </div>



    {#if data}

        <div id="overview-wrapper">

            <div class="wrapper">

                {#if selectedDate === 'all' && 'totalturnover' in data}

                    <h2>Total Umsatz</h2>

                    {#if Object.keys(data['totalturnover']).length !== 0}

                        <div class="table">

                            {#each Object.entries(data['totalturnover']['yearly_monthly_breakdown']) as [year, month]}

                                <div class="year-content">

                                    <h3>{year}</h3>

                                    <div class="yearly">
                                        {#each Object.entries(month['monthly_breakdown']) as [name, transactions]}

                                            <div class="monthly">

                                                <h4>{TRANSLATIONS[name]}</h4>
                                                <span>CHF {transactions['total']}.00</span>

<!--                                                <div class="transactions">-->

<!--                                                    {#each transactions['transactions'] as transaction}-->

<!--                                                        <div>-->
<!--                                                            <span>{dayjs.unix(transaction['created']).format('DD.MM.YY HH:mm')}</span>-->
<!--                                                            <span>CHF {transaction['amount']}.00</span>-->
<!--                                                        </div>-->


<!--                                                    {/each}-->
<!--                                                </div>-->
                                            </div>

                                        {/each}


                                    </div>

                                    <hr>

                                    <div class="yearly-total">Total CHF {month['total']}.00</div>

                                </div>

                            {/each}

                        </div>

                    {:else}

                        <div class="no-data">
                            <span>Keine Daten</span>
                        </div>

                    {/if}

                {:else if selectedDate === 'yearly' && 'yearly' in data}

                    <h2>{options['year']} Umsatz</h2>

                    {#if Object.keys(data['yearly']).length !== 0}

                        <div class="table" style="flex-direction: column; max-height: 50vh">

                            {#each Object.entries(data['yearly']['monthly_breakdown']) as [monthname, month]}

                                <div class="yearly monthly">

                                    <h4>{TRANSLATIONS[monthname]}</h4>

                                    <span>CHF {month['total']}.00</span>



                                </div>

                            {/each}

                            <hr>

                            <div class="yearly-total">Total CHF {data['yearly']['total']}.00</div>

                        </div>

                    {:else}

                        <div class="no-data">
                            <span>Keine Daten</span>
                        </div>

                    {/if}

                {:else if selectedDate === 'custom' && 'custom' in data}

                    {#if Object.keys(data['custom']).length !== 0}

                        <h2>{dayjs.unix(options['start']).format('DD.MM.YY')} - {dayjs.unix(options['end']).format('DD.MM.YY')} Umsatz</h2>

                        <div class="table">

                            {#each Object.entries(data['custom']['yearly_monthly_breakdown']) as [year, month]}

                                <div class="year-content">

                                    <h3>{year}</h3>

                                    <div class="yearly">
                                        {#each Object.entries(month['monthly_breakdown']) as [name, transactions]}

                                            <div class="monthly">

                                                <h4>{TRANSLATIONS[name]}</h4>
                                                <span>CHF {transactions['total']}.00</span>

                                                <!--                                                <div class="transactions">-->

                                                <!--                                                    {#each transactions['transactions'] as transaction}-->

                                                <!--                                                        <div>-->
                                                <!--                                                            <span>{dayjs.unix(transaction['created']).format('DD.MM.YY HH:mm')}</span>-->
                                                <!--                                                            <span>CHF {transaction['amount']}.00</span>-->
                                                <!--                                                        </div>-->


                                                <!--                                                    {/each}-->
                                                <!--                                                </div>-->
                                            </div>

                                        {/each}


                                    </div>

                                    <hr>

                                    <div class="yearly-total">Total CHF {month['total']}.00</div>

                                </div>

                            {/each}

                        </div>

                    {:else}

                        <div class="no-data">
                            <span>Keine Daten</span>
                        </div>

                    {/if}

                {/if}

            </div>

            {#if otherData}

                <div>
                    <div class="wrapper margindown">

                        <h2>Transaktionen letzten Monat</h2>

                        {#if Object.keys(otherData['turnovermonth']).length !== 0}

                            <table>

                                <tr class="header-row">

                                    <th class="list-date">Datum</th>
                                    <th>Betrag</th>

                                </tr>

                                {#each Object.entries(otherData['turnovermonth']['transactions']) as [key, transaction]}

                                    <tr>

                                        <td>{dayjs.unix(transaction['created']).format('DD.MM.YY HH:mm')}</td>
                                        <td class="amount">CHF {transaction['amount']}.00</td>

                                    </tr>

                                {/each}

                            </table>

                            <div class="list-total">
                                <span>Total: CHF {otherData['turnovermonth']['total']}.00</span>
                            </div>

                        {:else}

                            <div class="no-data">
                                <span>Keine Daten</span>
                            </div>

                        {/if}

                    </div>

                    <div class="multiple-wrapper wrapper">

                        <div class="upper">

                            <h2>Anzahl anstehende Auszahlungen</h2>

                            {#if Object.keys(otherData['payouts'][0]).length !== 0}

                                <div class="no-data">
                                    <span>{otherData['payouts'][0][0]}</span>
                                </div>

                            {/if}

                        </div>

                        <div class="lower">

                            <h2>Anzahl Mitglieder</h2>

                            {#if Object.keys(otherData['members']).length !== 0}

                                <div class="no-data">
                                    <span>{otherData['members'][0][0]}</span>
                                </div>

                            {/if}

                        </div>

                    </div>
                </div>


            {/if}



            <div class="wrapper downloads">

                <div>
                    <h2>Downloads</h2>

                    <div>
                        <h4>Management User CSV</h4>

                        <button class="btn entity-add" on:click={(e) => handleCsvDownload('member')}><span>Download CSV</span></button>
                    </div>

                    <div>
                        <h4>Total Umsatz CSV</h4>

                        <button class="btn entity-add" on:click={(e) => handleCsvDownload('turnover')}><span>Download CSV</span></button>
                    </div>

                    <div style="margin-top: 2vh">
                        <h4>Total eingelöste Gutscheine CSV</h4>

                        <button class="btn entity-add" on:click={(e) => handleCsvDownload('redeem')}><span>Download CSV</span></button>
                    </div>
                </div>



            </div>

        </div>


    {/if}

</div>


<style>

    #overview-container {
        position: relative;
        display: flex;
        flex-direction: column;
        width: calc(100vw - 40vh);
        padding-top: 4vh;
        height: calc(100vh - 4vh);
    }

    #overview-wrapper {
        display: flex;
        height: inherit;
        width: inherit;
        justify-content: space-evenly;
        align-items: center;
        flex-wrap: wrap;
    }

    #overview-wrapper .wrapper {
        background-color: white;
        -webkit-box-shadow: 0px 3px 10px 0px rgba(73, 119, 172, 0.08);
        -moz-box-shadow: 0px 3px 10px 0px rgba(73, 119, 172, 0.08);
        box-shadow: 0px 3px 10px 0px rgba(73, 119, 172, 0.08);
        padding: 4vh;
        border-radius: 1.5vh;
        height: min-content;
        font-family: 'Urbanist', sans-serif;
        flex: 0 1 auto;
    }

    .margindown {
        margin-bottom: 2vh;
    }

    .table {
        display: flex;
        flex-wrap: wrap;
        max-height: 50vh;
    }

    hr {
        width: 100%;
    }

    .monthly {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .monthly h4 {
        margin: 0.4vh 0;
    }
    .year-content{
        padding: 0 2vh;
        display: flex;
        flex-direction: column;
    }

    .yearly {
        width: 20vh;
    }

    h4 {
        margin: 0;
        font-weight: normal;
        font-size: 1.6vh;
    }

    .yearly-total {
        font-weight: bold;
        align-self: end;
    }

    h2 {
        font-size: 1.8vh;
    }


    .no-data {
        font-size: 1.5vh;
    }

    table {
        margin-top: 2vh;
        border-spacing: 0;
        display: block;
        overflow-y: auto;
        max-height: 55vh;

    }

    table th, table td {
        padding: 0.75vh;
        text-align: center;
        font-size: 1.5vh;
    }

    table th {
        width: 8vh;
    }

    table th.list-date {
        width: 10vh;
    }

    table th.list-user {
        width: 15vh;
    }

    .list-total {
        display: flex;
        justify-content: end;
        margin-top: 2vh;
    }

    .list-total span {
        font-size: 1.5vh;
        font-weight: 700;
    }

    .amount {
        text-align: end;
    }

</style>
